// ErrorPanel：API 错误统一展示，显示 code + message，并提供 Retry。

import { APIError, SessionExpiredError } from "@/api/client";
import { Button } from "./Button";

interface ErrorPanelProps {
  error: unknown;
  retry?: () => void;
}

function describe(error: unknown): { code: string; message: string } {
  if (error instanceof SessionExpiredError) {
    return { code: "unauthorized", message: error.message };
  }
  if (error instanceof APIError) {
    return { code: error.code, message: error.message };
  }
  if (error instanceof Error) {
    return { code: "unknown", message: error.message };
  }
  return { code: "unknown", message: String(error) };
}

export function ErrorPanel({ error, retry }: ErrorPanelProps) {
  const { code, message } = describe(error);
  return (
    <div className="rounded border border-[hsl(var(--border))] bg-[hsl(var(--danger-bg))] px-4 py-3 text-sm">
      <div className="font-mono text-xs text-[hsl(var(--muted-foreground))]">{code}</div>
      <div className="mt-1 text-[hsl(var(--foreground))]">{message}</div>
      {retry ? (
        <div className="mt-3">
          <Button variant="outline" size="sm" onClick={retry}>
            重试
          </Button>
        </div>
      ) : null}
    </div>
  );
}
